export enum VidePlayers {
  vlc = 'vlc',
  iina = 'iina'
}
